module.exports = __webpack_public_path__ + "static/img/smart1.1ba68f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/smart/smart1.jpg
// module id = fhvl
// module chunks = 1